export default "__VITE_ASSET__VPh1tgCw__"